import {Component, inject, signal} from '@angular/core';
import { RouterOutlet } from '@angular/router';
import {NgxUiLoaderModule} from 'ngx-ui-loader';
import {NetworkService} from './shared/services/network';
import {toSignal} from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, NgxUiLoaderModule],
  templateUrl: './app.html',
  styleUrl: './app.css'
})
export class App {
  private network = inject(NetworkService);

  protected readonly title = signal('Charge Clean');

  protected readonly isOnline = toSignal(
    this.network.isOnline$(),
    { initialValue: navigator.onLine }
  );
}
